import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const BillSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path>
      <path
        fill="currentColor"
        d="M3 5.5A2.5 2.5 0 0 1 5.5 3H18a3 3 0 0 1 3 3v14a1 1 0 0 1-1.524.852l-2.726-1.678l-2.726 1.678a1 1 0 0 1-1.048 0l-2.726-1.678l-2.726 1.678A1 1 0 0 1 6 20v-6H4a1 1 0 0 1-1-1zm5 12.71l1.726-1.062a1 1 0 0 1 1.048 0l2.726 1.678l2.726-1.678a1 1 0 0 1 1.048 0L19 18.21V6a1 1 0 0 0-1-1H7.95q.05.243.05.5zM5.5 5a.5.5 0 0 0-.5.5V12h1V5.5a.5.5 0 0 0-.5-.5M10 9a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1"
      ></path>
    </g>
  </svg>
);
const BillIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={BillSvg} {...props} />
);
export default BillIcon;
